import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../api/endpoints.js';
import { errorMessage } from '../api/client.js';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await forgotPassword(email.trim());
      setSent(true);
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-card__brand">
          <span className="sidebar__logo">◆</span>
          <span>Tips CRM</span>
        </div>
        <h1>Reset password</h1>

        {sent ? (
          <>
            <p className="muted">
              If an account exists for <strong>{email}</strong>, a reset link has been sent. The
              link expires in 1 hour.
            </p>
            <Link className="btn btn--block" to="/login">
              Back to sign in
            </Link>
          </>
        ) : (
          <>
            <p className="muted">Enter your email and we'll send you a link to reset your password.</p>
            <form onSubmit={handleSubmit} className="login-form">
              <label className="field">
                <span className="field__label">Email</span>
                <input
                  className="field__input"
                  type="email"
                  autoComplete="username"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  autoFocus
                />
              </label>
              {error && <div className="form-error" role="alert">{error}</div>}
              <button
                type="submit"
                className="btn btn--primary btn--block"
                disabled={submitting || !email}
              >
                {submitting ? 'Sending…' : 'Send reset link'}
              </button>
            </form>
            <p className="muted" style={{ marginTop: 16 }}>
              <Link to="/login">Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
